import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__